<template>
  <tab-page-template
    component-name="ControllerShow">

    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        コントローラ管理
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
        @click="omakaseDialog.visible = true;"
        v-if="isEditable"
        color="primary"
        class="mr-2"
      >
        <v-icon class="mr-2">mdi-checkbox-marked-circle-auto-outline</v-icon>
        辞書からおまかせ実装
      </v-btn>
      <v-btn
          @click="downloadCredentialFile"
          v-if="isEditable"
          color="primary"
      >
        <v-icon class="mr-2">mdi-key-variant</v-icon>
        コントローラーの認証ファイルダウンロード
      </v-btn>
    </template>

    <controller-info
      :controller="controllerView">
    </controller-info>

    <template #tab-items>
      <v-tab>サービス実装</v-tab>
      <v-tab>データ実装</v-tab>
      <v-tab-item>
        <service-implementation-table
          :serviceImplementations="serviceImplementations"
          :controllerId="controllerId">
        </service-implementation-table>
      </v-tab-item>
      <v-tab-item>
        <data-implementation-table
          :dataImplementations="dataImplementations"
          :controllerId="controllerId">
        </data-implementation-table>
      </v-tab-item>
    </template>

    <omakase-implementation-dialog
      v-model="omakaseDialog.visible"
      :initial-controller-id="controllerId"
    />
  </tab-page-template>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PathInfoMixin from "@/router/PathInfoMixin";
import IoablePageMixin from "@/router/IoablePageMixin";
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import ControllerInfo from "@/components/organisms/ControllerInfo.vue";
import ServiceImplementationTable from "@/components/pages/implementation/ControllerShow/ServiceImplementationTable.vue";
import DataImplementationTable from "@/components/pages/implementation/ControllerShow/DataImplementationTable.vue";
import FileUtils from "@/utils/FileUtils";
import TabPageTemplate from "@/components/templates/TabPageTemplate.vue";
import OmakaseImplementationDialog
  from "@/components/pages/implementation/ControllerShow/OmakaseImplementationDialog.vue";

export default {
  name: 'ControllerShow',
  components: {
    OmakaseImplementationDialog,
    TabPageTemplate,
    ControllerInfo,
    ServiceImplementationTable,
    DataImplementationTable
  },
  mixins: [
    PathInfoMixin,
    IoablePageMixin,
    FileUtils
  ],
  props: {
    controllerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      omakaseDialog: {
        visible: false,
      }
    };
  },
  computed: {
    ...mapState('hcs/controller', ['controller']),
    ...mapState('hcs/serviceImplementation', ['serviceImplementations']),
    ...mapState('hcs/dataImplementation', ['dataImplementations']),
    ...mapGetters({
      entities: 'hds/entities'
    }),
    controllerView() {
      return {
        ...this.controller,
      };
    }
  },
  methods: {
    load() {
      return Promise.all([
        this.$store.dispatch('hcs/controller/find', this.controllerId),
        this.$store.dispatch('hcs/serviceImplementation/findList', { controllerIdEq: this.controllerId }),
        this.$store.dispatch('hcs/dataImplementation/findList', { controllerIdEq: this.controllerId })
      ])
    },
    deleteServiceImplementation(id) {
      this.$store.dispatch('hcs/serviceImplementation/delete', id)
        .then(() => {
           this.$store.commit({
             type: 'showSnackbar',
             message: `サービス実装が削除されました`
           });
         })
         .catch(() => {
           this.$store.commit({
             type: 'showSnackbar',
             color: 'failed',
             message: `サービス実装の削除に失敗しました`
           });
         })
    },
    mergeServiceComponentModel(serviceImplementation) {
      const model = this.entities.serviceComponentModel.findOne({ id: serviceImplementation.serviceComponentModelId })
      this.$set(serviceImplementation, `name`, model?.name);
      this.$set(serviceImplementation, `description`, model?.description);
      return serviceImplementation
    },
    downloadCredentialFile() {
      this.$store.dispatch('hcs/controller/fetchDownloadCredential', this.controllerId)
        .then((response) => {
          this.downloadFile(response, 'EdgeControllerAPIKey.yml')
        })
       .catch(() => {
         this.$store.commit({
           type: 'showSnackbar',
           color: 'failed',
           message: `認証ファイルのダウンロードに失敗しました`
         });
       })
    }
  }
}
</script>
